<template>
  <master-layout smallTitle="nuova" bigTitle="Rilevazione" titleStyle="horizontal">
    <div class="relative">
      <div class="grid-center mb-4">
        <label v-if="loading" style="
            width: 100%;
            min-width: 300px;
            min-height: 150px;
            border-radius: 10px;
            display: grid;
            place-content: center;
            border: 1px solid goldenrod;
            color: goldenrod;
            font-weight: bold;
            font-size: 1.2rem;
            margin-top: 30px;
            padding: 1.2rem;
          ">Caricamento delle immagini in corso...</label>
        <button v-if="!loading" @click="triggerFileUploader" class="px-4 py-3 button-primary">
          {{
            rilevazione.elementiMultimediali.length > 0
              ? "Tocca per caricare altre immagini"
              : "Tocca per caricare immagini"
          }}
        </button>

        <div v-if="!loading" style="
            width: 100%;
            min-width: 300px;
            height: 150px;
            display: grid;
            place-content: center;
            border-radius: 10px;

            margin-top: 30px;
          " :style="{
            border: 1 + 'px dashed ' + (isDragging ? '#011307' : '#110F03'),
            'background-color': isDragging ? '#D8FDE5' : '#FCF9ED',
          }" @dragover.prevent.stop="onDragOver($event)" @dragleave.prevent.stop="onDragLeave($event)"
          @drop.prevent="onDrop($event)" @paste="handlePaste($event)">
          <span>O caricale trascinandole qui</span>
        </div>

        <input style="display: none" id="images-uploader" type="file" name="filefield" multiple
          @change="handleFileInput" />
      </div>
      <span v-if="rilevazione.elementiMultimediali.length > 0">Hai caricato delle immagini, scrolla in fondo alla pagina
        per vederne
        la miniatura</span>

      <div class="ion-margin-bottom ion-padding-bottom">
        <ion-row class="ion-margin-top ion-padding-top">
          <ion-col>
            <ion-item>
              <ion-textarea :autoGrow="true" :rows="2" placeholder="Descrizione"
                v-model="rilevazione.descrizione"></ion-textarea>
            </ion-item>
            <ion-item class="ion-margin-top">
              <ion-input :placeholder="loadingLuogoInizio ? 'Caricamento...' : 'Luogo'" inputmode="text"
                @ionFocus="setFocusTrue" @ionBlur="setFocusFalse" v-model="rilevazione.luogo" required></ion-input>
            </ion-item>
            <ion-item class="ion-margin-top ion-margin-bottom">
              <ion-datetime
                label="Fecha"
                label-placement="stacked"
                presentation="date"
                :min="minDate"
                :max="maxDate"
                :value="selectedDate"
                @ionChange="handleDateChange($event.detail.value)"
              ></ion-datetime>
            </ion-item>

            <ion-item class="ion-margin-top ion-margin-bottom">
              <ion-input
                ref="timeInput"
                label="Hora"
                label-placement="stacked"
                type="time"
                :value="selectedTime"
                :readonly="isServiceActive"
                @ionChange="handleTimeChange($event.detail.value)"
                @ionBlur="onTimeBlur"
              ></ion-input>
            </ion-item>
            <div v-if="isServiceActive" class="time-info ion-padding-start">
              <small style="color: #2dd36f; font-style: italic;">
                ⏱ L'ora viene aggiornata automaticamente mentre il servizio è attivo
              </small>
            </div>
            <div v-if="!isServiceActive" class="range-legend ion-padding-start ion-padding-top">
              <small>{{ allowedRangeText }}</small>
            </div>
          </ion-col>
        </ion-row>
      </div>

      <div class="ion-margin-bottom ion-padding background-white flex justify-content-start align-items-center">
        <span>Seleziona gli indagati:</span>

        <ion-select v-model="rilevazione.indagati" :multiple="true" :interface-options="{
          header: 'Seleziona gli indagati',
        }" class="ion-margin-top ion-margin-bottom">
          <ion-select-option v-for="indagato of ordineDiServizio.indagati" :key="indagato" :value="indagato">{{ indagato
            }}</ion-select-option>
        </ion-select>
      </div>

      <div class="galleria pb-6">
        <div @click="showModal(index)" class="gal-image" v-for="(image, index) in rilevazione.elementiMultimediali"
          :key="index">
          <img :src="image.urlElemento" @error="handleImgError" />
          <ion-icon @click="deleteImage(image)" :icon="trashOutline" class="delete-badge"></ion-icon>
        </div>
      </div>

      <button :disabled="loading || disabled" @click="salvaRilevazione"
        class="fixed bottom center button-bottom-axerta-secondary w-75 text-16">
        Salva
      </button>
    </div>
    <div id="bottom-component" class="bottom-component">
      <div v-if="tastieraFocus"></div>
    </div>
  </master-layout>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import MasterLayout from "../../components/MasterLayout.vue";
import { toastController } from "@ionic/vue";
import ApiService from "../../common/service.api";
import { trashOutline } from "ionicons/icons";
import { useAxertaStore } from "@/stores/useAxertaStore";
import { parseDate } from "@/utils/parseDate";
import axios from "axios";
import {
  IonAvatar,
  IonLabel,
  IonSelectOption,
  IonRow,
  IonCol,
  IonCard,
  IonList,
  IonItem,
  IonInput,
  IonSelect,
  IonTextarea,
  IonIcon,
  IonButton,
  IonFab,
  IonFabButton,
  modalController,
  IonDatetime,
  //   IonRouterOutlet,
  loadingController,
  IonLoading,
} from "@ionic/vue";

const route = useRoute();
const router = useRouter();

const AXERTA_STORE = useAxertaStore();

const ordineDiServizio = ref(AXERTA_STORE.ordineDiServizio);
console.log('STORE', ordineDiServizio)
const tastieraFocus = ref(false);
const isDragging = ref(false);

const luogoInizio = ref("");
const loadingLuogoInizio = ref(false);

onMounted(async () => {
  // get rilevazione from localhost
  // getRilevazioneFromLoocalHost();
  luogoInizio.value = "";
  await getUserLocation();
  initializeDateTime();
  /* rilevazione.value.indagati ? null : (rilevazione.value.indagati = []); */
  
  // If service is active, update time every minute
  if (isServiceActive.value) {
    timeUpdateInterval.value = setInterval(() => {
      const now = new Date();
      const hh = now.getHours().toString().padStart(2, "0");
      const mm = now.getMinutes().toString().padStart(2, "0");
      selectedTime.value = `${hh}:${mm}`;
      updateFinalDateTime();
    }, 60000); // Update every minute
  }
});

onBeforeUnmount(() => {
  if (timeTypingTimeout.value) {
    clearTimeout(timeTypingTimeout.value);
    timeTypingTimeout.value = null;
  }
  if (timeUpdateInterval.value) {
    clearInterval(timeUpdateInterval.value);
    timeUpdateInterval.value = null;
  }
});

async function getUserLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        await getLocationFrom(
          position.coords.latitude,
          position.coords.longitude
        );
      },
      (error) => {
        console.log(
          "🚀 ~ file: ProveEmmanuele.vue:29 ~ locatorButtonPressed ~ error:",
          error.message
        );
      }
    );
  } else {
    console.warn("Whappy ERR: Il tuo browser non supporta la GeoLocation API");
  }
}

async function getLocationFrom(lat, long) {
  loadingLuogoInizio.value = true;
  axios
    .get(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
      lat +
      "," +
      long +
      "&key=" +
      process.env.VUE_APP_GOOGLE_MAPS_API
    )
    .then((res) => {
      console.log('respuesta google', res)
      if (res.data.error_message) {
        console.log(
          "🚀 ~ file: ProveEmmanuele.vue:41 ~ getLocationFrom ~ res.data.error_message:",
          res.data.error_message
        );
      } else {
        luogoInizio.value = res.data.results[0].formatted_address;
        rilevazione.value.luogo = res.data.results[0].formatted_address;
      }
    })
    .catch((err) => {
      console.log(
        "🚀 ~ file: ProveEmmanuele.vue:46 ~ getLocationFrom ~ err:",
        err
      );
    })
    .finally(() => {
      loadingLuogoInizio.value = false;
    });
}

function deleteImage(image) {
  const index = rilevazione.value.elementiMultimediali.indexOf(image);
  rilevazione.value.elementiMultimediali.splice(index, 1);
}

function setFocusTrue() {
  tastieraFocus.value = true;
  scrollDown();
}
function setFocusFalse() {
  tastieraFocus.value = false;
}
function scrollDown() {
  document
    .querySelector("#bottom-component")
    .scrollIntoView({ behavior: "smooth" });
}

function onDragOver(event) {
  event.preventDefault();
  isDragging.value = true;
}
function onDragLeave(event) {
  event.preventDefault();
  isDragging.value = false;
}
function onDrop(event) {
  event.preventDefault();
  isDragging.value = false;
  handleFileInput({ target: { files: event.dataTransfer.files } });
}

function handlePaste(event) {
  console.log(event);
  // handleFileInput({ target: { files: event.clipboardData.files } });
}

const disabled = computed(() => {
  const isIndagatiEmptyInStore = ordineDiServizio.value.indagati?.length === 0;
  console.log('data ora', rilevazione.value.dataOra)
  console.log('indagati', rilevazione.value.indagati)
  console.log('isIndagatiEmptyInStore', isIndagatiEmptyInStore)
  console.log('descrizione', rilevazione.value.descrizione)
  console.log('luogo', rilevazione.value.luogo)
  console.log('elementiMultimediali', rilevazione.value.elementiMultimediali)
  if (
    rilevazione.value.luogo?.length > 0 &&
    rilevazione.value.descrizione?.length > 0 &&
    rilevazione.value.elementiMultimediali?.length > 0 &&
    rilevazione.value.dataOra?.length > 0 &&
    (rilevazione.value.indagati?.length > 0 || isIndagatiEmptyInStore)
  ) {
    return false; 
  }

  return true; 
});


const rilevazione = ref({
  descrizione: "",
  elementiMultimediali: [],
  luogo: "",
  dataOra: "",
  stato: "3",
});

function handleImgError() {
  return "https://placehold.co/300x300?text=MartechRevolution";
}

const minDate = computed(() => {
  // Return date-only string YYYY-MM-DD for IonDatetime
  if (!route.params || !route.params.inizioIntervento) return undefined;
  // slice instead of split("T") so "YYYY-MM-DD HH:mm:ss" (space separator) also works
  return route.params.inizioIntervento.toString().slice(0, 10);
});

// Date-only (YYYY-MM-DD, UTC) of a route date param; null if Safari can't parse it
function toDateOnly(value) {
  const d = parseDate(value);
  return d ? d.toISOString().split("T")[0] : null;
}

const maxDate = computed(() => {
  // For date picker we return date-only YYYY-MM-DD. If in-corso, use today's date.
  if (!route.params) return undefined;
  if (route.params.fineIntervento == "in-corso") {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const dd = d.getDate().toString().padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  } else if (route.params.fineIntervento) {
    return toDateOnly(route.params.fineIntervento) || undefined;
  }
  return undefined;
});

const isServiceActive = computed(() => {
  return route.params && route.params.fineIntervento === "in-corso";
});

const allowedRangeText = computed(() => {
  if (!route.params || !route.params.inizioIntervento) return "";
  const start = parseDate(route.params.inizioIntervento);
  if (!start) return "";
  const startDate = start.toISOString().split("T")[0];
  const startTime = start.toTimeString().slice(0, 5);

  if (route.params.fineIntervento === "in-corso") {
    const now = new Date();
    const endDate = now.toISOString().split("T")[0];
    const endTime = now.toTimeString().slice(0, 5);
    return `Intervallo consentito: ${startDate} ${startTime} — ${endDate} ${endTime} (fino ad ora)`;
  }

  const end = parseDate(route.params.fineIntervento);
  if (!end) return "";
  const endTime = end.toTimeString().slice(0, 5);
  return `Intervallo consentito: ${startTime} —  ${endTime}`;
});

const modalVisible = ref(false);
const currentImageIndex = ref("");

function handleDateTimeChange(event) {
  console.log("handle datetime change", event);

  let ora = event;

  rilevazione.value.dataOra = ora;

  console.log("handle datetime change", rilevazione.value);
}

// Separate date and time handling (like in ModificaRilevazione)
const selectedDate = ref("");
const selectedTime = ref("");
const timeInput = ref(null);
const timeTypingTimeout = ref(null);
const timeUpdateInterval = ref(null);
const lastValidTime = ref("");

watch(selectedTime, (newVal, oldVal) => {
  // Only act when user has entered a complete time string 'HH:mm'
  if (!newVal || typeof newVal !== "string") return;
  console.log('[NuovaRilevazione] watcher selectedTime ->', { newVal, oldVal, selectedDate: selectedDate.value, lastValidTime: lastValidTime.value });
  if (newVal.length === 5) {
    // Debounce clamping to avoid reacting mid-typing when the webcomponent normalizes partial input
    if (timeTypingTimeout.value) {
      clearTimeout(timeTypingTimeout.value);
      timeTypingTimeout.value = null;
    }
    timeTypingTimeout.value = setTimeout(() => {
      const res = clampOrValidateTime(newVal);
      console.log('[NuovaRilevazione] clampOrValidateTime result (debounced)', res);
      if (res.isClamped) {
        console.log('[NuovaRilevazione] Clamping time (debounced)', newVal, '->', res.clamped);
        selectedTime.value = res.clamped;
        nextTick(() => {
          try {
            if (timeInput.value && timeInput.value.getInputElement) {
              timeInput.value.getInputElement().then((el) => { if (el) el.value = selectedTime.value; });
            }
          } catch (e) {
            /* ignore */
          }
        });
        lastValidTime.value = res.clamped;
      } else if (res.withinRange) {
        lastValidTime.value = newVal;
      }
      updateFinalDateTime();
    }, 600);
  }
});

function handleDateChange(value) {
  if (!value) return;
  // value can be 'YYYY-MM-DD' or full ISO; normalize to YYYY-MM-DD
  selectedDate.value = value.includes("T") ? value.split("T")[0] : value;
  // clamp selectedDate between minDate and maxDate
  if (minDate.value && selectedDate.value < minDate.value) selectedDate.value = minDate.value;
  if (maxDate.value && selectedDate.value > maxDate.value) selectedDate.value = maxDate.value;
  // if after clamping we landed on a boundary, ensure time is within bounds
  enforceTimeBoundsForSelectedDate();
  updateFinalDateTime();
}

function handleTimeChange(value) {
  if (!value) return;
  // value is expected as 'HH:mm' (ion-input time)
  selectedTime.value = value;
  // ensure time respects min/max when on boundary dates
  enforceTimeBoundsForSelectedDate();
  updateFinalDateTime();
}

function onTimeBlur() {
  // When user finishes editing, validate/clamp only if necessary.
  if (!selectedTime.value || selectedTime.value.length !== 5) {
    // incomplete input — restore last valid time if available
    if (lastValidTime.value && lastValidTime.value.length === 5) {
      selectedTime.value = lastValidTime.value;
      nextTick(() => {
        try {
          if (timeInput.value && timeInput.value.getInputElement) {
            timeInput.value.getInputElement().then((el) => { if (el) el.value = selectedTime.value; });
          }
        } catch (e) {
          /* ignore */
        }
        updateFinalDateTime();
      });
    }
    return;
  }

  const res = clampOrValidateTime(selectedTime.value);
  if (res.isClamped) {
    selectedTime.value = res.clamped;
    lastValidTime.value = res.clamped;
    nextTick(() => {
      try {
        if (timeInput.value && timeInput.value.getInputElement) {
          timeInput.value.getInputElement().then((el) => { if (el) el.value = selectedTime.value; });
        }
      } catch (e) {
        /* ignore */
      }
      updateFinalDateTime();
    });
  } else {
    // valid full time
    lastValidTime.value = selectedTime.value;
    updateFinalDateTime();
  }
}

function getTimeFromISO(iso) {
  if (!iso) return null;
  try {
    const d = parseDate(iso);
    if (!d) return null;
    const hh = d.getHours().toString().padStart(2, "0");
    const mm = d.getMinutes().toString().padStart(2, "0");
    return `${hh}:${mm}`;
  } catch (e) {
    return null;
  }
}

function timeToMinutes(hhmm) {
  if (!hhmm || typeof hhmm !== "string") return null;
  const parts = hhmm.split(":");
  if (parts.length < 2) return null;
  const hh = parseInt(parts[0], 10);
  const mm = parseInt(parts[1], 10);
  if (isNaN(hh) || isNaN(mm)) return null;
  return hh * 60 + mm;
}

function clampOrValidateTime(timeStr) {
  // returns { withinRange: bool, isClamped: bool, clamped: string }
  if (!timeStr || timeStr.length !== 5) return { withinRange: false, isClamped: false, clamped: timeStr };
  const tMin = timeToMinutes(timeStr);
  if (tMin === null) return { withinRange: false, isClamped: false, clamped: timeStr };

  // compute start and end minutes for the currently selectedDate
  let startMin = null;
  let endMin = null;
  if (route.params && route.params.inizioIntervento) {
    const s = getTimeFromISO(route.params.inizioIntervento);
    startMin = timeToMinutes(s || "00:00");
  }
  if (route.params) {
    if (route.params.fineIntervento === "in-corso") {
      const now = new Date();
      const n = `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}`;
      endMin = timeToMinutes(n);
    } else if (route.params.fineIntervento) {
      const e = getTimeFromISO(route.params.fineIntervento);
      endMin = timeToMinutes(e || "23:59");
    }
  }

  // If selectedDate is not on the start or end boundary, it's within range
  const startDateOnly = route.params && route.params.inizioIntervento ? toDateOnly(route.params.inizioIntervento) : null;
  const endDateOnly = route.params && route.params.fineIntervento && route.params.fineIntervento !== "in-corso" ? toDateOnly(route.params.fineIntervento) : (route.params && route.params.fineIntervento === "in-corso" ? new Date().toISOString().split("T")[0] : null);

  if (selectedDate.value && startDateOnly && selectedDate.value === startDateOnly && startMin !== null && tMin < startMin) {
    // clamp to start
    const hh = Math.floor(startMin / 60).toString().padStart(2, "0");
    const mm = (startMin % 60).toString().padStart(2, "0");
    return { withinRange: false, isClamped: true, clamped: `${hh}:${mm}` };
  }

  if (selectedDate.value && endDateOnly && selectedDate.value === endDateOnly && endMin !== null && tMin > endMin) {
    // clamp to end
    const hh = Math.floor(endMin / 60).toString().padStart(2, "0");
    const mm = (endMin % 60).toString().padStart(2, "0");
    return { withinRange: false, isClamped: true, clamped: `${hh}:${mm}` };
  }

  // otherwise it's within range
  return { withinRange: true, isClamped: false, clamped: timeStr };
}

function enforceTimeBoundsForSelectedDate() {
  console.log('[NuovaRilevazione] enforceTimeBoundsForSelectedDate start', { selectedDate: selectedDate.value, selectedTime: selectedTime.value });
  // If selectedDate equals minDate, ensure selectedTime >= start time
  if (!selectedDate.value) return;
  if (route.params && route.params.inizioIntervento) {
    const startDateOnly = toDateOnly(route.params.inizioIntervento);
    if (startDateOnly && selectedDate.value === startDateOnly) {
      const startTime = getTimeFromISO(route.params.inizioIntervento) || "00:00";
      console.log('[NuovaRilevazione] compare with startTime', { startTime });
      if (selectedTime.value < startTime) {
        console.log('[NuovaRilevazione] clamping up to startTime', startTime);
        selectedTime.value = startTime;
        nextTick(() => {
          try {
            if (timeInput.value && timeInput.value.getInputElement) {
              timeInput.value.getInputElement().then((el) => { if (el) el.value = selectedTime.value; });
            }
          } catch (e) {
            /* ignore */
          }
        });
      }
    }
  }

  // If selectedDate equals maxDate, ensure selectedTime <= end time (or now if in-corso)
  if (route.params) {
    const endIsInCorso = route.params.fineIntervento === "in-corso";
    const endTime = endIsInCorso ? getTimeFromISO(new Date().toISOString()) : getTimeFromISO(route.params.fineIntervento);
    console.log('[NuovaRilevazione] compare with endTime', { endTime, endIsInCorso });
    if (endTime && selectedDate.value === (endIsInCorso ? new Date().toISOString().split("T")[0] : toDateOnly(route.params.fineIntervento))) {
      if (selectedTime.value > endTime) {
        console.log('[NuovaRilevazione] clamping down to endTime', endTime);
        selectedTime.value = endTime;
        nextTick(() => {
          try {
            if (timeInput.value && timeInput.value.getInputElement) {
              timeInput.value.getInputElement().then((el) => { if (el) el.value = selectedTime.value; });
            }
          } catch (e) {
            /* ignore */
          }
        });
      }
    }
  }
}

function updateFinalDateTime() {
  if (selectedDate.value && selectedTime.value) {
    rilevazione.value.dataOra = `${selectedDate.value}T${selectedTime.value}:00`;
  } else {
    rilevazione.value.dataOra = "";
  }
}

function initializeDateTime() {
  // choose an initial date: prefer current date if within range, else clamp to min/max
  const today = new Date().toISOString().split("T")[0];
  let initialDate = today;
  if (minDate.value && initialDate < minDate.value) initialDate = minDate.value;
  if (maxDate.value && initialDate > maxDate.value) initialDate = maxDate.value;
  selectedDate.value = initialDate;

  // initial time: current time, but clamp if on boundary
  const now = new Date();
  const hh = now.getHours().toString().padStart(2, "0");
  const mm = now.getMinutes().toString().padStart(2, "0");
  selectedTime.value = `${hh}:${mm}`;
  enforceTimeBoundsForSelectedDate();
  updateFinalDateTime();
  // initialize last valid time
  if (selectedTime.value && selectedTime.value.length === 5) lastValidTime.value = selectedTime.value;
}

const loading = ref(false);

function handleFileInput(event) {
  loading.value = true;
  const promises = [];

  for (let i = 0; i < event.target.files.length; i++) {
    const formData = new FormData();
    formData.append("file", event.target.files[i]);
    promises.push(
      ApiService.post("Upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    );
  }

  Promise.allSettled(promises)
    .then((results) => {
      let failed = 0;
      results.forEach((result) => {
        if (result.status === "fulfilled" && result.value?.data) {
          rilevazione.value.elementiMultimediali.push({
            urlElemento: "https://api-axerta.whappy.it/Drive/" + result.value.data,
          });
        } else {
          failed++;
          console.error("Errore caricamento file", result.reason || result);
        }
      });

      if (failed === 0) {
        presentToast(results.length > 1 ? "File caricati" : "File caricato");
      } else if (failed === results.length) {
        presentToast("Errore nel caricamento delle immagini, riprova", "danger");
      } else {
        presentToast(`${failed} di ${results.length} immagini non sono state caricate`, "warning");
      }
    })
    .finally(() => {
      loading.value = false;
      // reset so the same file can be selected again after a failed upload
      const input = document.getElementById("images-uploader");
      if (input) input.value = "";
    });
}






function salvaRilevazione() {
  loading.value = true;
  disabled.value = true;
  if (!rilevazione.value.indagati) rilevazione.value.indagati = [];
  // Validate that dataOra is within inizio/fine range
  const start = route.params && route.params.inizioIntervento ? parseDate(route.params.inizioIntervento) : null;
  const end = route.params && route.params.fineIntervento && route.params.fineIntervento !== "in-corso" ? parseDate(route.params.fineIntervento) : new Date();
  const candidate = rilevazione.value.dataOra ? parseDate(rilevazione.value.dataOra) : null;
  if (candidate && start && candidate < start) {
    loading.value = false;
    disabled.value = false;
    presentToast("La data/ora deve essere successiva all'inizio dell'intervento");
    return;
  }
  if (candidate && end && candidate > end) {
    loading.value = false;
    disabled.value = false;
    presentToast("La data/ora deve essere precedente alla fine dell'intervento");
    return;
  }
  ApiService.post(
    "DossierManager/AddRilevazioneDettaglio/" + route.params.idIntervento,
    rilevazione.value
  )
    .then((res) => {
      console.log(" success salva rilevazione ", res);
    })
    .finally(() => {
      rilevazione.value = {
        descrizione: "",
        elementiMultimediali: [],
        luogo: "",
        dataOra: "",
      };
      loading.value = false;
      disabled.value = false;
      router.push(
        {
          name: "ElencoRilevazioni",
          params: {
            idOrdine: route.params.idOrdine,
            idIntervento: route.params.idIntervento,
            inizioIntervento: route.params.inizioIntervento,
            fineIntervento: route.params.fineIntervento
              ? route.params.fineIntervento
              : "in-corso",
          },
        }

        // "/axerta/elenco-rilevazioni/" +
        //   route.params.idOrdine +
        //   "/" +
        //   route.params.idIntervento
      );
    });
}

async function presentToast(message, color = "success") {
  const toast = await toastController.create({
    message: message,
    duration: color === "success" ? 1500 : 3000,
    position: "bottom",
    color: color,
  });

  await toast.present();
}

function triggerFileUploader() {
  document.getElementById("images-uploader").click();
}
</script>

<style lang="scss" scoped>
.hello {
  position: relative;
}

.icon {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
}

.galleria {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  padding: 10px;
}

.gal-image {
  position: relative;
  max-width: 30%;
  min-width: 100px;

  img {
    width: 100%;
    height: auto;
    border: 3px solid gray;
    border-radius: 5px;
  }

  .delete-badge {
    position: absolute;
    background-color: maroon;
    color: white;
    padding: 0.6rem;
    border-radius: 50%;
    top: -10px;
    right: -10px;
  }
}

.active {
  img {
    border: 4px solid rgb(85, 194, 85);
  }
}

.relative {
  position: relative;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 900000;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  padding: 1rem;
  background-color: rgb(255, 255, 255);
  // border: 2px solid gray;
  border-radius: 10px;
  box-shadow: 0px 9px 46px 8px rgba(0, 0, 0, 0.12),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px rgba(0, 0, 0, 0.2);

  .header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .image-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-grow: 1;
    padding: 1rem 0;
  }

  .current-image {
    display: grid;
    place-content: center;
  }
}

input[type="file"] {
  border: 1px solid rgb(165, 165, 165);
  border-radius: 7px;
  padding: 1rem 2rem;
}

// .custom-file-upload {
//   border: 1px solid #ccc;
//   display: inline-block;
//   padding: 6px 12px;
//   margin-bottom: 3rem;
//   border-radius: 5px;
//   padding: 0.5rem 1rem;
//   cursor: pointer;
//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03), 0px 0px 2px rgba(0, 0, 0, 0.06),
//     0px 2px 6px rgba(0, 0, 0, 0.12);
// }

.bottom-component {
  width: 100%;
  padding-top: 50vh;
}

.range-legend {
  color: #000000;
  font-size: 1rem;
  background-color: rgba(172, 224, 30, 0.527);
  padding: 0.4rem 0.6rem;
}
</style>
